import React, {useState, useEffect} from 'react'
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter'
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioPublicacion from './FormularioPublicacion'
import Cargando from '../elementos/Cargando'
import favicon from '../imagenes/logoutm.png'

const EditarPublicacion = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [publicacion, setPublicacion] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarPublicacionID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setPublicacion(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Actualizar Publicación</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Actualizar Publicación</Titulo>
                    <BtnRegresar ruta="/publicaciones"/>
            </Header>

            <FormularioPublicacion  publicacion={publicacion}/>
            </>
        );
    }
}
 
export default withRouter(EditarPublicacion);